import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Solutions from '../components/Solutions';
import SolutionThemes from '../components/SolutionThemes';
import Footer from '../components/Footer';

const Home = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="home-container">
      <Header />
      <Hero scrollY={scrollY} />
      <About />
      <Solutions />
      <SolutionThemes />
      <Footer />
    </div>
  );
};

export default Home;
